import React, { useState, useEffect } from "react";
import { IonGrid, IonRow } from "@ionic/react";
import Loader from "../../components/Shared/Loader/Loader";
import _ from "lodash";
import { Accordion, AccordionTab } from "primereact/accordion";
import { unitDeptListService } from "../UnitDeptList/UnitDept.service";
import UnitDeptListCardComponent from "../../components/Shared/ListCard/UnitDeptListCard";
import { utilService } from "../../services/utilService";
import "./GlobalUnitSearch.scss";
import NoResults from "../../components/Shared/NoResults/NoResultsComponent";

interface accordionProps {
  searchInput: any;
}

const GlobalUnitSearch: React.FC<accordionProps> = (props) => {
  const nextPage = "units";
  const [favUnitList, setfavUnitList]: any = useState();
  const [showLoader, setShowLoader]: [boolean, Function] = useState(false);
  var [UnitListData, setUnitListData]: any = useState([]);
  const [activeIndex, setActiveIndex]: any = useState(null);
  const [favouriteIcon, setFavouriteIcon]: any = useState();

  useEffect(() => {
    fetchUnitDetails();
  }, [props?.searchInput]);

  const triggerList = () => {
    //added comment
    fetchUnitDetails();
  };

  const fetchUnitDetails = async () => {
    setShowLoader(true);
    let params = {};
    const respUnitListResult: any = await unitDeptListService.getUnitListData(
      props?.searchInput,
      params
    );

    if (respUnitListResult?.isSuccess) {
      setfavUnitList(
        respUnitListResult?.unitListResult?.[0]?.fav_unit_list?.data
      );
      setUnitListData(respUnitListResult?.unitListResult?.[0]?.all_list?.data);
    } else {
      console.log("error");
      unitDeptListService.handleErrorResponse();
    }

    setShowLoader(false);
  };

  const setFavourite = async (scheduleListItem: any) => {
    setFavouriteIcon((value: any) => !value);
    var favBoolValue = scheduleListItem?.fav;

    let params: any = {
      siteId: scheduleListItem?.site_id,
      Reg_code: utilService.getNetwork(),
      fav: favBoolValue,
    };
    const respTeammatesList = await unitDeptListService.getSiteFavouriteList(
      params,
      scheduleListItem?.site_id
    );
    if (respTeammatesList.isSuccess && respTeammatesList.result) {
      fetchUnitDetails();
      setActiveIndex(null);
    }
  };

  return (
    <div className="sites-page-container">
      {showLoader && (
        <div className="loader-container">
          <Loader></Loader>
        </div>
      )}
      <IonGrid>
        <div className="accordion-wrapper">
          <Accordion
            style={{ overflowY: "auto" }}
            className="favunit-accordion"
          >
            <AccordionTab header="Favorite Units">
              <div className="accordion-content-container">
                <IonRow>
                  {!_.isEmpty(favUnitList) ? (
                    favUnitList?.map((item: any, index: any) => (
                      <UnitDeptListCardComponent
                        key={item.id}
                        listData={item}
                        componentName={nextPage}
                        setParentListData={setUnitListData}
                        parentSource={"units"}
                        triggerList={triggerList}
                      />
                    ))
                  ) : (
                    <div className="no-results-label">No Units Available</div>
                  )}
                </IonRow>
              </div>
            </AccordionTab>
          </Accordion>
        </div>

        <div className="title-container d-flex justify-content-between">
          <div className="d-flex align-items-center">
            <span className="title-label">All Sites</span>
          </div>
        </div>

        <div className="accordion-wrapper">
          {UnitListData && UnitListData.length == 0 ? (
            <div className="no-results-label">
              <NoResults></NoResults>
            </div>
          ) : (
            <Accordion
              multiple
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e?.index)}
              className="sites-accordion"
            >
              {UnitListData?.map((scheduleListItem: any, index: any) => {
                return (
                  <AccordionTab
                    key={scheduleListItem.site_name}
                    header={
                      <React.Fragment>
                        <span className="tab-header-value">
                          {scheduleListItem.site_name} -
                          {scheduleListItem.location}
                        </span>

                        <div
                          className={`fav-team ${
                            scheduleListItem.fav !== false
                              ? "input-icon icon-favorite_fill"
                              : "input-icon icon-favorite"
                          }`}
                          onClick={(e: any) => {
                            if (scheduleListItem.fav == true) {
                              scheduleListItem.fav = false;
                            } else {
                              scheduleListItem.fav = true;
                            }
                            setFavourite(scheduleListItem);
                          }}
                        ></div>
                      </React.Fragment>
                    }
                  >
                    <div className="accordion-content-container">
                      <IonRow>
                        {!_.isEmpty(scheduleListItem?.units_or_departments) ? (
                          scheduleListItem?.units_or_departments?.map(
                            (item: any, index: any) => (
                              <UnitDeptListCardComponent
                                key={item.id}
                                listData={item}
                                componentName={nextPage}
                                setParentListData={setUnitListData}
                                parentSource={"units"}
                                triggerList={triggerList}
                              />
                            )
                          )
                        ) : (
                          <div className="no-results-label">
                            No Units Available
                          </div>
                        )}
                      </IonRow>
                    </div>
                  </AccordionTab>
                );
              })}
            </Accordion>
          )}
        </div>
      </IonGrid>
    </div>
  );
};

export default GlobalUnitSearch;
